import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import { BaseActivity, BaseActivityText } from '@/components/activities/BaseActivity/BaseActivity';
import IconDone from '@/icons/Done.svg';

export const ArticleExchangeStockAvailabilityConfirmedActivity = ({
  activity,
}: {
  activity: ActivityOfType<'article_exchange_stock_availability_confirmed'>;
}) => {
  const stockLocationName = activity.entity.name;
  const creatorName = activity.creator.name;
  const productName = activity.data.replacementProduct.name;

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="primary"
      icon={<IconDone />}
      message={
        <BaseActivityText>
          {activity.data.onBehalfOfStockLocation ? (
            <Trans id="activities.article_exchange_stock_availability_confirmed.message.on-behalf">
              <strong>{creatorName}</strong> confirmed stock availability of product {productName}{' '}
              on behalf of {stockLocationName}
            </Trans>
          ) : (
            <Trans id="activities.article_exchange_stock_availability_confirmed.message">
              <strong>{creatorName}</strong> confirmed stock availability of product {productName}
            </Trans>
          )}
        </BaseActivityText>
      }
    />
  );
};
